<form [formGroup]="policyForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'entityId-' + policy.id" class="col-sm-5 col-form-label">{{ 'COMMON.ENTITY' | translate }}</label>
        <div class="col-sm-7">
          <!--<select *ngIf="entities && action =='edit' "class="form-select" [id]="'entityId-' + policy.id" formControlName="entityId">
            <option [value]="entity.id" *ngFor="let entity of entities">{{ entity.name }}</option>
          </select>   *ngIf="entities && action =='create' " -->
          <div *ngIf="action==='edit'" class="col-sm-7 align_middle">
            {{entity? entity.name! : user.entity? user.entity.name : ''}}
          </div>
          <!--<hbo-single-select-multi-level *ngIf="action==='create'" [tree]="entities" [userEntity]="user"
            [selection]="entity" [typeData]="'policy'" [max]="2" [selection]="entity" formControlName="entityId">
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="action==='create' && configSvc.currentConfigValue.childEntities && user.profileId === 3"
            [customTreeNode]="childEntities"
            (callbackClickOutside)="onChange($event)"
            [typeData]="'policy'"
            [clearSelector]="clearEntitiesSelector"
            (callbackObject)="onChangeObject($event)"></app-basic-virtual-scroll>
          <hbo-control-messages [control]="policyForm.get('entityId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="teams.length > 0">
        <label [for]="'teamId-' + policy.id" class="col-sm-5 col-form-label">{{ 'USER.TEAM' | translate }}</label>
        <div class="col-sm-7">
          <select class="form-select" [id]="'teamId-' + policy.id" formControlName="teamId"
            [class.d-none]="policyForm.controls.allTeams.value">
            <option value="" [disabled]="distributorPolicyTaken">{{ 'DATATABLE.COLUMN.DISTRIBUTOR' | translate }}</option>
            <option [value]="team.id" [disabled]="isTeamTaken(team.id)" *ngFor="let team of teams">{{ team.name }}</option>
          </select>
          <div class="form-check mt-2" *ngIf="action === 'create'">
            <input class="form-check-input" type="checkbox" [id]="'allTeams-' + policy.id" formControlName="allTeams">
            <label class="form-check-label" [for]="'allTeams-' + policy.id">
              {{ 'DATATABLE.FILTERS.ALLTEAMS' | translate }}
            </label>
          </div>
        </div>
      </div>

      <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" [id]="'seeLicenses-' + policy.id" formControlName="seeLicenses">
        <label class="form-check-label" [for]="'seeLicenses-' + policy.id">
          {{ 'LICENSE.ALLOW_SEE' | translate }}
        </label>
      </div>
    </div>

    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'LICENSE.PACKAGE_AVAILABILITY' | translate }}</h4>

      <div class="row row-cols-auto" *ngFor="let packageType of packageTypes">
        <div class="form-check mb-3 col-4">
          <input class="form-check-input" type="checkbox" [id]="'packageType-' + policy.id + '-' + packageType.id"
            (click)="togglePackage(packageType.id)" [checked]="packageChecked(packageType.id)" [disabled]="user.profileId !== 3 || isPackageTypeRestrictedByDistributor(packageType.id)">
          <label class="form-check-label" [for]="'packageType-' + policy.id + '-' + packageType.id">
            {{ packageType.name }}
          </label>
        </div>
        <div class="row mb-3 col-8">
          <label [for]="'packageTypeDays-' + policy.id + '-' + packageType.id" class="col-sm-5 col-form-label">{{
            'LICENSE.DEFAULT_TEST_DAYS' | translate }}</label>
          <div class="col-sm-7">
            <input type="number" class="form-control" [id]="'packageTypeDays-' + policy.id + '-' + packageType.id"
              [value]="getPackageTestDays(packageType.id)" (change)="setPackageTestDays(packageType.id, $event.target)"
              [disabled]="!packageChecked(packageType.id) || user.profileId !== 3">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId === 3">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark" [ngClass]="{'submit-pb-disabled':!policyForm.valid}">{{
      'COMMON.SAVE_CHANGES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + policy.id" *ngIf="action === 'edit'">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>
  </div>
</form>

<hbo-confirmation-modal [id]="policy.id" (confirm)="delete()"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="'policy'" (confirm)="cancel()" [head]="'POLICY.EXISTS'" [message]="'false'" [confirmText]="'COMMON.NEW_POLICY'"></hbo-confirmation-modal>